/**
 * Converts a saved vehicle object into a calendar event object.
 * Supports both camelCase frontend fields and Athena snake_case aliases.
 * Returns null if desiredDate / ba_soll is missing or invalid.
 */
export function vehicleToEvent(vehicle) {
  const dateStr = vehicle.desiredDate || vehicle.ba_soll;
  if (!dateStr) return null;
  const d = new Date(dateStr);
  if (isNaN(d)) return null;  return {
    row: d.getDate(),
    col: d.getMonth() + 1,    label: vehicle.vehicleNumber || vehicle.fahrzeugnummer || vehicle.vehicleName || "New",
    _vehicleId: vehicle.id,
    _projektname: vehicle.projektname || vehicle.projectName || null,
    _aktuelle_station: vehicle.aktuelle_station || vehicle.assemblyLine || null,
    _fahrzeugnummer: (vehicle.fahrzeugnummer || vehicle.vehicleNumber || "").toLowerCase(),
  };
}

/**
 * Calculates delay in days relative to today.
 * Accepts a date string directly, or a vehicle object (reads desiredDate / ba_soll).
 */
export function calcDelay(input) {
  const dateStr = (input && typeof input === "object")
    ? (input.desiredDate || input.ba_soll)
    : input;
  if (!dateStr) return "–";
  const today = new Date();
  const d = new Date(dateStr);
  if (isNaN(d)) return "–";
  const diff = Math.round((d - today) / (1000 * 60 * 60 * 24));
  return diff >= 0 ? `+${diff}` : `${diff}`;
}
